import { createSlice } from "@reduxjs/toolkit";
import {
  addSaga,
  createAsyncSaga,
  createSagaReducer,
  persist,
  sagaSlice,
} from "./sagaStore";
import fetchShopAdminDashboardOrderData from "../services/fetchShopAdminDashboardOrderData";
import deliveryAgentPaymentSummaryService from "../services/deliveryAgentPaymentSummary";
import deliveryAgentItemsSummaryService from "../services/deliveryAgentItemsSummary";
import { ShopAdminDashboardState } from "../types/order";

const initialState: ShopAdminDashboardState = {
  list: {
    loading: false,
    error: null,
    data: {},
  },
  paymentsData: {
    loading: false,
    error: null,
    data: null,
  },
  itemsData: {
    loading: false,
    error: null,
    data: null,
  },
  startDate: null,
  endDate: null,
  selectedDate: null,
  selectedPeriod: "today",
  activeTab: "payments",
};

const Slice: sagaSlice = createSlice({
  ...persist("shopAdminDashboard", initialState),
  reducers: {
    ...createSagaReducer("getShopAdminDashboardOrderData", "list"),
    ...createSagaReducer("getDeliveryAgentPaymentSummary", "paymentsData"),
    ...createSagaReducer("getDeliveryAgentItemsSummary", "itemsData"),
    updateStartDate(state, action) {
      state.startDate = action.payload;
    },
    updateEndDate(state, action) {
      state.endDate = action.payload;
    },
    updateSelectedDate(state, action) {
      state.selectedDate = action.payload;
    },
    updateSelectedPeriod(state, action) {
      state.selectedPeriod = action.payload;
    },
    updateActiveTab(state, action) {
      state.activeTab = action.payload;
    },
  },
});

const fetchShopAdminDashboardOrderDataSaga = createAsyncSaga(
  "getShopAdminDashboardOrderData",
  Slice,
  fetchShopAdminDashboardOrderData.getShopAdminDashboardOrderData,
  ["startDate", "endDate"]
);

const fetchDeliveryAgentPaymentSummarySaga = createAsyncSaga(
  "getDeliveryAgentPaymentSummary",
  Slice,
  deliveryAgentPaymentSummaryService.getDeliveryAgentPaymentSummary,
  ["shopId", "startDate", "endDate"]
);

const fetchDeliveryAgentItemsSummarySaga = createAsyncSaga(
  "getDeliveryAgentItemsSummary",
  Slice,
  deliveryAgentItemsSummaryService.getDeliveryAgentItemsSummary,
  ["shopId", "startDate", "endDate"]
);

addSaga(
  Slice.actions.getShopAdminDashboardOrderData.type,
  fetchShopAdminDashboardOrderDataSaga
);

addSaga(
  Slice.actions.getDeliveryAgentPaymentSummary.type,
  fetchDeliveryAgentPaymentSummarySaga
);

addSaga(
  Slice.actions.getDeliveryAgentItemsSummary.type,
  fetchDeliveryAgentItemsSummarySaga
);

export const {
  getShopAdminDashboardOrderData,
  getDeliveryAgentPaymentSummary,
  getDeliveryAgentItemsSummary,
  updateStartDate,
  updateEndDate,
  updateSelectedDate,
  updateSelectedPeriod,
  updateActiveTab,
} = Slice.actions;

export default Slice.reducer;
